import { b64Encode } from "./utils";

export type AdKey = Record<string, string>;

export const isCampaign = (adKey: AdKey) =>
  typeof adKey.campaign === "string" && typeof adKey.adset !== "string";
export const isAd = (adKey: AdKey) => typeof adKey.ad === "string";
export const isAdset = (adKey: AdKey) =>
  typeof adKey.adset === "string" && typeof adKey.ad !== "string";

export const getId = (adKey: AdKey) =>
  adKey.ad ?? adKey.adset ?? adKey.campaign;

export const level = (adKey: AdKey) => {
  if (isCampaign(adKey)) {
    return "campaign";
  }
  if (isAdset(adKey)) {
    return "adset";
  }
  // isAd(adKey)
  return "ad";
};

export const shouldShowLabels = (adKey: AdKey) => {
  return true;
};

export const isAdKeyObjectKey = (key: string) =>
  key === "kind" ||
  key === "platform" ||
  key === "campaign" ||
  key === "adset" ||
  key === "ad";

export const isCustomSpend = (adKey: AdKey) =>
  adKey.kind === "custom_spend" || adKey.kind === "custom_spend_api";

const getAdNameFromAdKey = (adKey: AdKey): string => {
  const formatIdHelper = (id: string): string => {
    if (id) {
      return id;
    } else {
      return "N/A";
    }
  };

  const humanReadableAdName = [];
  if (isAd(adKey)) {
    humanReadableAdName.push("Ad ID: " + formatIdHelper(adKey.ad));
  }
  if (isAdset(adKey) || isAd(adKey)) {
    humanReadableAdName.push("Adset ID: " + formatIdHelper(adKey.adset));
  }
  humanReadableAdName.push("Campaign ID: " + formatIdHelper(adKey.campaign));

  return humanReadableAdName.join(", ");
};

export const getAdName = (
  isAnon: boolean,
  adName: any,
  adKey: AdKey,
): string => {
  if (adName instanceof Error || !adName) {
    const key = getAdNameFromAdKey(adKey);
    return isAnon ? b64Encode(key) : key;
  }

  // Influencers fallback name
  if (adName.includes("partnership-") && adName.split("-").length === 2) {
    const platform =
      {
        youtube: "YouTube",
        instagram: "Instagram",
        tiktok: "TikTok",
        podcast: "Podcast",
        twitter: "Twitter",
        twitch: "Twitch",
        lp: "Other",
      }[adKey.platform.split("-")[1]] || null;
    if (platform != null) {
      const partner = adKey.campaign.toUpperCase();
      const potentiallyAnonedPartner = isAnon ? b64Encode(partner) : partner;
      return `${potentiallyAnonedPartner} - ${platform}`;
    }
  }
  return isAnon ? b64Encode(adName) : adName;
};
